import type { EmailServiceSubmitFormRequest } from 'apiConnector/email-service';
import { emailServiceApiConnector } from 'apiConnector/email-service';
import type { NextWorkflowError } from 'models/NextWorkflowError';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { getBlotterPanelItemId } from 'state/blotters/blotterPanel/blotterPanel.selector';
import {
  emailServicePreviewContentFailed,
  emailServicePreviewContentReceived,
} from 'state/emailService/emailService.actions';
import {
  getEmailServiceAvailableDocuments,
  getEmailServiceEmailRecipient,
  getEmailServiceEmailSubject,
} from 'state/emailService/emailService.selectors';
import type { EpicWithThunk } from 'state/state.common';
import type { HttpError } from 'utils/http/httpClient.model';

export function emailServicePreviewFormEpic(): EpicWithThunk {
  return (actions$, state$, { httpClient }) =>
    actions$.pipe(
      ofType('EMAIL_SERVICE_RECIPIENT_CHANGED', 'EMAIL_SERVICE_MODAL_OPENED'),
      withLatestFrom(state$),
      switchMap(([_, state]) => {
        const tradeId = getBlotterPanelItemId(state);
        const subject = getEmailServiceEmailSubject(state);
        const recipient = getEmailServiceEmailRecipient(state);
        const documents = getEmailServiceAvailableDocuments(state);

        if (!tradeId || documents.length < 1) {
          return EMPTY;
        }

        const request: EmailServiceSubmitFormRequest = { subject, recipient, documents };

        return emailServiceApiConnector(httpClient)
          .preview(tradeId, request)
          .pipe(
            map(({ payload }) => emailServicePreviewContentReceived(payload)),
            catchError((e: HttpError<{ rejections: NextWorkflowError[] }>) =>
              of(emailServicePreviewContentFailed(e.payload?.rejections)),
            ),
          );
      }),
    );
}
